import React from 'react';
import { createPortal } from 'react-dom';
import './SessionExpiredModal.scss';

interface SessionExpiredModalProps {
  isOpen: boolean;
  onLogin: () => void;
  message?: string;
}

const SessionExpiredModal: React.FC<SessionExpiredModalProps> = ({ 
  isOpen, 
  onLogin,
  message = "Your session has expired. Please log in again to continue."
}) => {
  if (!isOpen) return null;

  const modalContent = (
    <div className="session-expired-overlay">
      <div className="session-expired-modal">
        <div className="session-expired-icon">🔒</div>
        <h2>Session Expired</h2>
        <p>{message}</p>
        <button 
          className="session-expired-login-button"
          onClick={onLogin}
        >
          Log In Again
        </button>
      </div>
    </div>
  );

  return createPortal(modalContent, document.body);
};

export default SessionExpiredModal;


